module.exports = __webpack_public_path__ + "img/shot_tx19112503.cf701915.jpg";